import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Typography, Card, CardContent, Box, Modal, Button,
  IconButton, TextField, MenuItem
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import StarIcon from '@mui/icons-material/Star';
import RateReviewIcon from '@mui/icons-material/RateReview';

export default function AdminFeedbackPage() {
  const [feedbackList, setFeedbackList] = useState([]);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [ratingFilter, setRatingFilter] = useState('');
  const [commentSearch, setCommentSearch] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/feedback`)
      .then(res => setFeedbackList(res.data))
      .catch(err => console.error('Geri bildirimler alınamadı:', err));
  }, []);

  const averageRating = (
    feedbackList.reduce((sum, f) => sum + f.rating, 0) / feedbackList.length || 0
  ).toFixed(1);

  const filteredFeedbacks = feedbackList.filter(f => {
    const matchRating = ratingFilter ? f.rating === parseInt(ratingFilter) : true;
    const matchComment = f.comment.toLowerCase().includes(commentSearch.toLowerCase());
    return matchRating && matchComment;
  });

  const handleView = (row) => {
    setSelectedFeedback(row);
    setModalOpen(true);
  };

  const columns = [
    { field: 'userId', headerName: 'Kullanıcı ID', flex: 1 },
    { field: "userName", headerName: "Kullanıcı Adı", flex: 1, minWidth: 160 },
    { field: 'rating', headerName: 'Puan', flex: 0.5 },
    {
      field: 'comment',
      headerName: 'Yorum',
      flex: 2,
      renderCell: (params) => (
        <span>{params.row.comment?.slice(0, 50)}...</span>
      )
    },
    {
      field: 'actions',
      headerName: 'İşlemler',
      flex: 1,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => handleView(params.row)}>
            <VisibilityIcon />
          </IconButton>
          <IconButton disabled title="Silme henüz aktif değil">
            <DeleteIcon />
          </IconButton>
        </>
      )
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      {/* Dashboard Kartlar */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 3,
        mb: 3,
        flexWrap: 'wrap',
      }}>
        <Card sx={{ width: 220, textAlign: 'center',  boxShadow: 3 }}>
          <CardContent>
            <StarIcon sx={{ fontSize: 40, color: '#fdd835' }} />
            <Typography variant="subtitle2" color="text.secondary" mt={1}>Ortalama Puan</Typography>
            <Typography variant="h5" fontWeight={600}>{averageRating}</Typography>
          </CardContent>
        </Card>
        <Card sx={{ width: 220, textAlign: 'center',  boxShadow: 3 }}>
          <CardContent>
            <RateReviewIcon sx={{ fontSize: 40, color: '#1976d2' }} />
            <Typography variant="subtitle2" color="text.secondary" mt={1}>Toplam Yorum</Typography>
            <Typography variant="h5" fontWeight={600}>{feedbackList.length}</Typography>
          </CardContent>
        </Card>
      </Box>

      {/* Filtre Alanları */}
      <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
        <TextField
          label="Yorumda ara"
          value={commentSearch}
          onChange={(e) => setCommentSearch(e.target.value)}
          sx={{ minWidth: 240 }}
        />
        <TextField
          label="Puan Filtrele"
          select
          value={ratingFilter}
          onChange={(e) => setRatingFilter(e.target.value)}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="">Hepsi</MenuItem>
          {[5, 4, 3, 2, 1].map(r => <MenuItem key={r} value={r}>{r} Yıldız</MenuItem>)}
        </TextField>
      </Box>

      {/* Liste */}
      <Box sx={{ width: '97%', overflowX: 'auto',justifyContent: 'center' }}>
        <div style={{ minWidth: 800, height: 500 }}>
          <DataGrid
            rows={filteredFeedbacks.map((f, i) => ({ id: i, ...f }))}
            columns={columns}
            pageSize={10}
          />
        </div>
      </Box>

      {/* Modal */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box sx={{
          p: 6, bgcolor: 'white', mx: 'auto', my: '10%', width: 400, borderRadius: 2
        }}>
          <Typography variant="h6">Yorum Detayı</Typography>
          <Typography variant="body2" mt={2}><strong>Kullanıcı:</strong> {selectedFeedback?.userId}</Typography>
          <Typography variant="body2"><strong>Puan:</strong> {selectedFeedback?.rating}</Typography>
          <Typography variant="body2" mt={2}><strong>Yorum:</strong> {selectedFeedback?.comment}</Typography>
          <Box mt={3} display="flex" justifyContent="flex-end"><Button variant="contained" onClick={() => setModalOpen(false)}>Kapat</Button></Box>
        </Box>
      </Modal>
    </Box>
  );
}
